/** @jsxImportSource @emotion/react */
import { useState } from "react";
import PropTypes from "prop-types";
import { h100css } from "assets/css/dimensions";
import useEvent from "hooks/useEvent";
import tableActionFieldCss from "./index.css";
import EmailThreadDetailModal from "./EmailThreadDetailModal";

export default function TableActionField({ row }) {
  const [isAnalyticOpen, setIsAnalyticOpen] = useState(false);

  const onCloseAnalyticModal = useEvent(() => setIsAnalyticOpen(false));
  const onOpenAnalyticModal = useEvent(() => setIsAnalyticOpen(true));

  return (
    <div css={[tableActionFieldCss.actionSelectWrapper, h100css]}>
      <EmailThreadDetailModal
        isOpen={isAnalyticOpen}
        onOpenModal={onOpenAnalyticModal}
        onCloseModal={onCloseAnalyticModal}
        rowData={row.original}
      />
    </div>
  );
}

TableActionField.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
  }).isRequired,
};
